export default function initbaseDocumentaireScroll(): void {
    const $baseDocumentaireScroll = document.querySelectorAll<HTMLElement>('.js-results-base-documentaire');
    $baseDocumentaireScroll.forEach($container => {
        new BaseDocumentaireScroll($container);
    });
}

class BaseDocumentaireScroll {
    $el: HTMLElement | null | undefined;
    $nav: HTMLElement | null | undefined;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$nav = document.getElementById('main-header');
        this.init();
    }

    init(): void {
        if (this.$el) {
            const isFiltered = document.location.href.includes('/categorie');
            const navHeight = this.$nav?.offsetHeight;

            if (isFiltered && navHeight) {
                window.scrollTo({
                    behavior: 'smooth',
                    left: 0,
                    top: this.$el?.offsetTop - navHeight,
                })

            }
        }
    }
}
